import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { AgreementsService } from 'src/app/api/collaborator/agreements.service';
import { SearchPartnercompaniesComponent } from 'src/app/components/search-partnercompanies/search-partnercompanies.component';
import flatpickr from 'flatpickr';
import { RatesService } from 'src/app/api/hospitality/rates.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-agreements-form',
  templateUrl: './agreements-form.component.html',
  styleUrls: ['./agreements-form.component.css']
})
export class AgreementsFormComponent implements OnInit, AfterViewInit {
  @ViewChild(SearchPartnercompaniesComponent)
  SearchPartnercompaniesComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  partnerSelected: any = null;
  flatpickrStart: any;
  flatpickrEnd: any;
  rates_detail: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private agreementService: AgreementsService,
    private ratesService: RatesService,
    public toolsService: ToolsService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      partnercompany_id: [null, [Validators.required]],
      description: [null, [Validators.required]],
      start_date: [null],
      end_date: [null],
      conditions: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    } else {
      this.getRates();
    }
  }

  ngAfterViewInit(): void {
    this.flatpickrStart = flatpickr('#start_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });

    this.flatpickrEnd = flatpickr('#end_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  editData() {
    this.agreementService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;

        this.item.patchValue({
          description: item_.description,
          start_date: item_.start_date,
          end_date: item_.end_date,
        });

        this.rates_detail = data.rates_detail;

        this.selectedPartnerSearch(item_.partner_company_data);

        if (this.flatpickrStart) {
          this.flatpickrStart.setDate(item_.start_date, true, 'Y-m-d');
        }
        if (this.flatpickrEnd) {
          this.flatpickrEnd.setDate(item_.end_date, true, 'Y-m-d');
        }
      }
    });
  }

  getRates() {
    this.ratesService.all().subscribe({
      next: (data: any) => {
        let datos = data.results.map((item: any) => {
          return {
            ...item,
            rates_roomtype: item.rates_roomtype.map((room: any) => {
              return {
                ...room,
                detail_id: null,
                agreement: null // 👈 aquí se agrega dentro de cada roomtype
              };
            })
          };
        });

        this.rates_detail = [...datos];
      }
    });
  }
  

  changePriceAgreement(param: any, index: number, index_detail: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.rates_detail[index].rates_roomtype[index_detail].agreement = value_;
    }
  }

  selectedPartnerSearch(item_: any) {
    this.partnerSelected = item_;
    if(this.isEdit){
      this.partnerSelected.document_str = "DOC: "+item_.document;
    }
    this.item.patchValue({
      partnercompany_id: this.partnerSelected.id
    });
  }

  removePartner() {
    this.partnerSelected = null;
    this.item.patchValue({
      partnercompany_id: null
    });
    setTimeout(() => {
      this.SearchPartnercompaniesComponent.focused();
    }, 150);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    data.item = this.item.value;
    data.rates_detail = this.rates_detail;

    if (this.validate()) {
      if (this.isEdit) {
        this.agreementService.update(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.agreementService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    for (let i in this.rates_detail) {
      let temporada = this.rates_detail[i];
      if (temporada.rates_roomtype.length > 0) {
        for (let j in temporada.rates_roomtype) {
          let room = temporada.rates_roomtype[j];
          if (Number(room.agreement) == 0 || _.isNull(room.agreement)) {
            this.alertifyMsg.warning(
              'El S/ Precio Convenio no puede ser 0 ó estar vacío'
            );
            (<any>$('#price_agreement' + i + j)).focus();
            return false;
          }
        }
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/colaborador/convenios/lista'
    ]);
  }
}
